import { DownOutlined } from '@ant-design/icons';
import { Button, Dropdown, message, Space } from 'antd';

const ThemeDropdown = ({
  text,
  items,
  className,
  large,
  setValue,
  disabled,
}) => {
  const handleMenuClick = e => {
    setValue(e.key);
  };
  const menuProps = {
    items,
    onClick: handleMenuClick,
  };

  return (
    <Dropdown menu={menuProps} className={className} disabled={disabled}>
      <Button className={large && 'h-10'} disabled={disabled}>
        <Space className="flex items-center justify-between">
          {text}
          <DownOutlined />
        </Space>
      </Button>
    </Dropdown>
  );
};

export default ThemeDropdown;
